import React, { useContext, useEffect, useState } from 'react';
import CountryPhoneInput, { ConfigProvider } from 'antd-country-phone-input';
import en from 'world_countries_lists/data/countries/en/world.json';
import nl from 'world_countries_lists/data/countries/nl/world.json';
import fr from 'world_countries_lists/data/countries/fr/world.json';
import 'antd-country-phone-input/dist/index.css';
import { oneOf } from 'prop-types';
import { getCountries } from 'libphonenumber-js';
import { ApplicationUIContext } from '../Provider/Provider';
import { convertPhoneNumberStringToObject } from './InputPhoneHelpers';

const filterSort = (a, b) => {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
};

const InputPhone = ({ locale = 'en', defaultCountryCode = 'CA', value, onChange }) => {
  const [chosenLocale, setChosenLocale] = useState(en);
  const { isMobile } = useContext(ApplicationUIContext);

  useEffect(() => {
    switch (locale) {
      case 'nl':
        setChosenLocale(nl);
        break;
      case 'fr':
        setChosenLocale(fr);
        break;
      default:
        setChosenLocale(en);
        break;
    }
  }, [locale]);

  // TODO: Support excludeCountries
  // TODO: Support onlyCountries
  // TODO: Support preferredCountries

  return (
    <ConfigProvider locale={chosenLocale}>
      <CountryPhoneInput
        selectProps={{ filterSort }}
        size={isMobile ? 'large' : 'middle'}
        inline
        defaultValue={{ short: defaultCountryCode }}
        onChange={onChange}
        style={{ paddingTop: 0, paddingBottom: 0 }}
        value={convertPhoneNumberStringToObject(value)}
      />
    </ConfigProvider>
  );
};

InputPhone.propTypes = {
  locale: oneOf(['en', 'nl', 'fr']),
  defaultCountryCode: oneOf(getCountries()),
};

export { InputPhone };
